import { ref } from "vue";
import { getAllComments, getCommentById, getCommentsByLead, addComment, updateComment, deleteComment } from "../../api/comments";

const state = {
    comments: ref([]),
    comment: ref({}),
    isLoading: ref(false),
};

const actions = {
    /**
     * جلب جميع التعليقات
     */
    async fetchComments({ commit }, page) {
        try {
            const response = await getAllComments(page);
            commit('SET_COMMENTS', response.data);
        } catch (error) {
            console.log(error);
        }
    },

    /**
     * جلب تعليق معين حسب الـ ID
     */
    async fetchCommentById({ commit }, id) {
        try {
            const response = await getCommentById(id);
            commit('SET_COMMENT', response.data);
        } catch (error) {
            console.log(error);
        }
    },

    /**
     * جلب التعليقات الخاصة بـ lead_id معين
     */
    async fetchCommentsByLead({ commit }, leadId) {
        try {
            const response = await getCommentsByLead(leadId); // Fetch comments for a specific lead
            commit('SET_COMMENTS', response); // Assuming the response has the comments
        } catch (error) {
            console.log(error);
        }
    },

    /**
     * إنشاء تعليق جديد
     */
    async addNewComment({ commit }, comment) {
        try {
            const response = await addComment(comment);
            commit('ADD_COMMENT', response);
        } catch (error) {
            console.log(error);
        }
    },

    /**
     * تحديث بيانات تعليق معين
     */
    async updateComment({ commit }, comment) {
        try {
            const response = await updateComment(comment.id, comment);
            commit('UPDATE_COMMENT', response.data.comment);
        } catch (error) {
            console.log(error);
        }
    },

    /**
     * حذف تعليق
     */
    async deleteComment({ commit }, id) {
        try {
            await deleteComment(id);
            commit('DELETE_COMMENT', id);
        } catch (error) {
            console.log(error);
        }
    },
};

const mutations = {
    SET_COMMENTS(state, comments) {
        state.comments = comments;
    },
    SET_COMMENT(state, comment) {
        state.comment = comment;
    },
    ADD_COMMENT(state, comment) {
        if (!state.comments) {
            state.comments = []; // تأكد من أن comments ليست undefined
        }
        state.comments.push(comment);
    },
    UPDATE_COMMENT(state, updatedComment) {
        state.comments = state.comments.map(comment => comment.id === updatedComment.id ? updatedComment : comment);
    },
    DELETE_COMMENT(state, id) {
        state.comments = state.comments.filter(comment => comment.id !== id);
    },
};

const getters = {
    getComments: (state) => state.comments,
    getComment: (state) => state.comment,
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
